import { useEffect, useState } from 'react';
import Image from 'next/image';
import { roundNumber } from '../../shared/utils';

export const ItemImage = ({
  itemId,
  width = 36,
  height = 48,
  scale = 1.0,
  imageNumber = 1,
  onImageNotFound = () => {},
}) => {
  const sessionStorageName = `[${itemId}][${imageNumber}].noImage`;
  const fallBackSrc = '/noimageavailable.jpg';

  useEffect(() => {
    setImgSrc(getImageUrl());
  }, [itemId, imageNumber]);

  const noImage = !!window.sessionStorage.getItem(sessionStorageName);

  const getImageUrl = () =>
    (!noImage &&
      `${
        process.env.NEXT_PUBLIC_CDN_URL
      }?itemId=${itemId}&imageIndex=${imageNumber}&width=${scale * 120}`) ||
    fallBackSrc;

  const [imgSrc, setImgSrc] = useState(getImageUrl());

  return (
    (itemId && (
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: roundNumber(height * scale, 0),
        }}
      >
        <Image
          src={imgSrc}
          onError={() => {
            setImgSrc(fallBackSrc);
            // Do not try loading the missing image from CDN
            // if the image does not exist for this browser session.
            window.sessionStorage.setItem(sessionStorageName, true);
            onImageNotFound();
          }}
          onLoad={() => {
            if (window.sessionStorage.getItem(sessionStorageName)) {
              onImageNotFound();
            }
          }}
          alt={`${itemId}`}
          style={{ objectFit: 'contain' }}
          fill
          sizes='25vw'
        />
      </div>
    )) ||
    null
  );
};
